import styled from "styled-components";
import colours from "../../lib/colours";

export const Link = styled.a`
  color: ${colours.th1};
  word-wrap: break-word;
`;
